import React from "react";
import { useLocation } from 'react-router-dom';
import { Link as ScrollLink, Element } from 'react-scroll';
import classnames from "classnames"; // nodejs library that concatenates strings
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  NavbarToggler,
  Container,
  Dropdown, 
  DropdownToggle, 
  DropdownMenu, 
  DropdownItem,
} from "reactstrap";

import logo from 'assets/img/logo.webp';
import LandingPageHeader from "components/Headers/LandingPageHeader";
import MainFooter from "components/Footers/MainFooter";

import Mission from "views/Mission";
import HyperDrive from "views/HyperDrive";
import Leadership from "views/Leadership";
import Careers from "views/Careers";
import News from "views/News";
import Partners from "views/Partners";
import Investors from "views/Investors";
import Contact from "views/ContactV2";
import TrustedBy from "views/TrustedBy";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const MainNavbar = () => {

  const url = useLocation();
  const urlSplit = url.pathname.split("/");
  var event = "";
  if (urlSplit.length == 2) {
    event = urlSplit[1];
  }
  console.log(event);
    
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);
  const [dropdownOpenTeam, setDropdownOpenTeam] = React.useState(false);
  const [dropdownOpenMedia, setDropdownOpenMedia] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleMobileNav = () => {
    setNavbarCollapse(!navbarCollapse);
    setMobileNavOpen(!mobileNavOpen);
  };

  const toggleNavbarCollapse = () => {
    // Close the dropdowns when Navbar collapses
    // setDropdownOpenTeam(false);
    // setDropdownOpenMedia(false);
  };

  const toggleDropdownTeam = () => {
    setDropdownOpenTeam(!dropdownOpenTeam);
    // Close the other dropdown
    setDropdownOpenMedia(false);
  };

  const toggleDropdownMedia = () => {
    setDropdownOpenMedia(!dropdownOpenMedia);
    // Close the other dropdown
    setDropdownOpenTeam(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(false);
    setDropdownOpenTeam(false);
    setDropdownOpenMedia(false)
    // Close the other dropdown
  };

  const closeMobileNav = () => {
    setMobileNavOpen(false);
  };

  return (
    <div>
      
      {/* Navbar for md, lg, and xl screens */}
      <Navbar
        className={classnames("fixed-top", {
          "navbar-collapsed": navbarCollapse,
        })}
        expand="lg" // Set to 'sm' for small screens
        style={{
          background: "linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))",
        }}
      >
        <Container>
          {/* ... (NavbarBrand and NavbarToggler) */}
          <NavbarBrand
            data-placement="bottom"
            href="/"
            title="Maglev Aero"
            className="mr-auto"
          >
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: "25%", height: "auto" }}
            />
          </NavbarBrand>
          <NavbarToggler
            onClick={toggleNavbarCollapse}
            aria-expanded={navbarCollapse}
            className="navbar-toggler ml-auto"
          >
            <FontAwesomeIcon icon={faBars} style={{ color: 'white' }} onClick={toggleMobileNav} />
          </NavbarToggler>
          <Collapse className="d-lg-flex justify-content-end" navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    href="#"
                    to="Home" // Replace with the name of your contact section Element
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', padding: 'none', fontSize: '1.0rem', color: 'white', fontWeight:'normal'}}
                  >
                    Home
                </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                  className ='nav-link'
                  to="Company" // Replace with the name of your contact section Element
                  href="#"
                  spy={true}
                  smooth={true}
                  offset={-70} // Adjust the offset if necessary
                  duration={500} // Duration of the scroll animation
                  style={{cursor: 'pointer', fontSize: '1.0rem', color: 'white', fontWeight:'normal'}}
                >
                  Mission
                </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                  className ='nav-link'
                  to="Hyperdrive" // Replace with the name of your contact section Element
                  href="#"
                  spy={true}
                  smooth={true}
                  offset={-70} // Adjust the offset if necessary
                  duration={500} // Duration of the scroll animation
                  style={{cursor: 'pointer', fontSize: '1.0rem', color: 'white', fontWeight:'normal'}}
                >
                  HyperDrive
                </ScrollLink>
              </NavItem>
              <NavItem>
                <Dropdown isOpen={dropdownOpenTeam} toggle={toggleDropdownTeam} >
                  <DropdownToggle nav caret style={{ cursor: 'pointer', fontSize: '1.0rem', color: 'white', fontWeight: 'normal' }}>
                    Team
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem >
                    <div onClick={toggleDropdownTeam}>
                      <ScrollLink
                        to="Leadership" // Replace with the name of your Leadership section Element
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        Leadership
                      </ScrollLink>
                      </div>
                    </DropdownItem>
                    <DropdownItem>
                    <div onClick={toggleDropdownTeam}>
                      <ScrollLink
                        to="Careers" // Replace with the name of your Careers section Element
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        Join Us
                      </ScrollLink>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
              <NavItem>
                <Dropdown isOpen={dropdownOpenMedia} toggle={toggleDropdownMedia}>
                  <DropdownToggle nav caret style={{ cursor: 'pointer', fontSize: '1.0rem', color: 'white', fontWeight: 'normal' }}>
                    Media
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={toggleDropdownMedia}>
                      <ScrollLink
                        to="Media" // Replace with the name of your Leadership section Element
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        In the News
                      </ScrollLink>
                    </DropdownItem>
                    <DropdownItem onClick={toggleDropdownMedia}>
                      <ScrollLink
                        to="Partners" // Replace with the name of your Careers section Element
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        Partners
                      </ScrollLink>
                    </DropdownItem>
                    <DropdownItem onClick={toggleDropdownMedia}>
                      <ScrollLink
                        to="TrustedBy"
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        Trusted By
                      </ScrollLink>
                    </DropdownItem>
                    <DropdownItem onClick={toggleDropdownMedia}>
                      <ScrollLink
                        to="Investors" // Replace with the name of your Careers section Element
                        href="#"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{color:'#02223A', fontWeight:'normal', padding:'10px',  paddingRight:'40px'}}
                        onClick={toggleDropdown}
                      >
                        Investors
                      </ScrollLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Contact" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.0rem', color: 'white', fontWeight:'normal'}}
                  >
                    Contact
                </ScrollLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      
      {/* Sidebar for mobile (sm and xs screens) */}
      <div className="d-lg-none">
        <Collapse isOpen={mobileNavOpen} className="d-lg-none">
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.95)",
              zIndex: 1000,
            }}
            onClick={closeMobileNav}
          >
            {/* Your sidebar content goes here */}
            <Nav className="text-center" vertical style={{ padding: '20px', marginTop: '120px' }}>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Home"
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', padding: 'none', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Home
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                  className ='nav-link'
                  to="Company" // Replace with the name of your contact section Element
                  href="#"
                  spy={true}
                  smooth={true}
                  offset={-70} // Adjust the offset if necessary
                  duration={500} // Duration of the scroll animation
                  style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                  onClick={closeMobileNav}
                >
                  Mission
                </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                  className ='nav-link'
                  to="Hyperdrive" // Replace with the name of your contact section Element
                  href="#"
                  spy={true}
                  smooth={true}
                  offset={-70} // Adjust the offset if necessary
                  duration={500} // Duration of the scroll animation
                  style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                  onClick={closeMobileNav}
                >
                  HyperDrive
                </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Leadership" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Leadership
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Careers" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Join Us
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Media" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    In The News
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Partners" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Partners
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Investors" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Investors
                  </ScrollLink>
              </NavItem>
              <NavItem>
                <ScrollLink
                    className ='nav-link'
                    to="Contact" // Replace with the name of your contact section Element
                    href="#"
                    spy={true}
                    smooth={true}
                    offset={-70} // Adjust the offset if necessary
                    duration={500} // Duration of the scroll animation
                    style={{cursor: 'pointer', fontSize: '1.5rem', color: 'white', fontWeight:'normal'}}
                    onClick={closeMobileNav}
                  >
                    Contact
                </ScrollLink>
              </NavItem>
            </Nav>
          </div>
        </Collapse>
      </div>

      {/* Main Page */}
      <Element name="Home"><LandingPageHeader event={event}/></Element>
      <Element name="Company"><Mission/></Element>
      <Element name="Hyperdrive"><HyperDrive event={event}/></Element>
      <Element name="Leadership"><Leadership/></Element>
      <Element name="Careers"><Careers/></Element>
      <Element name="Media"><News/></Element>
      <Element name="Partners"><Partners/></Element>
      <Element name="TrustedBy"><TrustedBy/></Element>
      <Element name="Investors"><Investors/></Element>
      <Element name="Contact"><Contact/></Element>
      <MainFooter/>

    </div>
  );
}

export default MainNavbar;
